import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import Alert from '@mui/material/Alert';

import LoginForm from "../components/LoginForm/LoginForm";
import style from "../components/LoginForm/LoginForm.module.css";
import star from "../assets/star.png";

import { useTranslation } from 'react-i18next';
import { useAuth } from '../providers/AuthContext';
import { googleCallback as apiGoogleCallback, login as apiLogin, register as apiRegister } from "../api/auth";

const logo='/Okboard_logo_1.svg';

function Login() {
  const [searchParams] = useSearchParams();
  const promoFromUrl = searchParams.get("code") || "";
  const initialMode = promoFromUrl ? "signup" : (searchParams.get("mode") || "signin");
  const [mode, setMode] = useState(initialMode);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const { authUser, isLoggedIn, login, logout } = useAuth();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    full_name: "",
    company_name: "",
    promo_code: promoFromUrl,
  });

  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async (response) => {
      try {
        const data = await apiGoogleCallback(response.code);
        await login(data.token);
        navigate("/dashboard");
      } catch (err) {
        console.error("Google Login Error:", err);
        setError(err.message);
      }
    },
    onError: (error) => {
      console.error("Google Login Error", error);
    },
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = mode === "signin"
        ? await apiLogin(formData.email, formData.password)
        : await apiRegister(formData);
      await login(data.token);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    {error && 
    <Alert 
      variant="outlined" 
      severity="error"
      sx={{ maxWidth: "500px", width: "100%", margin: "5% auto 0 auto" }}
    >
      {error}
    </Alert>}
    <div className={style.formContainer}>
      <img className={`${style.starDecor} ${style.decor1}`} src={star} alt=""/>
      
      <div className={style.formHeader}>
        <div>
          <h2>{mode === "signin" ? t('auth.login_tab') : t('auth.register_tab')}</h2>
        </div>
        <div><span className={'login-logo'} aria-label="OKboard" /></div>
      </div>
      
      
      <LoginForm
        mode={mode}
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        loading={loading}
        googleLogin={googleLogin}
        setMode={setMode}
        promoOpen={!!promoFromUrl}
      />
      <img className={`${style.starDecor} ${style.decor2}`} src={star} alt=""/>
      <img className={`${style.starDecor} ${style.decor3}`} src={star} alt=""/>
    </div>
    </>
  );
}

const styles = {
  error: {
    color: "red",
  },
};

export default Login;
